import React, { FC, useState } from 'react';

import { getFraudReportDownload } from '../../../services/TenantReports/FraudReport.service';
import usePagination from '../../../shared/hooks/usePagination';
import FraudReportFilter from './FraudReportFilter';
import FraudReportDownloadTable from './FraudReportTable';

const FraudReport: FC = () => {
  const [refreshView, setRefreshView] = useState<string>('');
  const {
    data,
    isLoading,
    page,
    offset,
    setPage,
    setOffset
  } = usePagination(getFraudReportDownload, [refreshView]);
  return (
    <div style={{ padding: '2rem' }}>
      <div>
        <h4>Fraud Report</h4>
      </div>
      <FraudReportFilter setRefreshView={setRefreshView} />
      <FraudReportDownloadTable
        reports={data || []}
        isLoading={isLoading}
        page={page}
        offset={offset}
        setPage={setPage}
        setOffset={setOffset}
      />
    </div>
  );
};

export default FraudReport;
